import { render, staticRenderFns } from "./PayrollDetailInfo.vue?vue&type=template&id=2b1a1c93"
import script from "./PayrollDetailInfo.vue?vue&type=script&lang=js"
export * from "./PayrollDetailInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports